// a regex pattern for email validation
export const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const argumentPattern = /^%%(\d+)%%$/;
